"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalManager = void 0;
var PortalManager = /** @class */ (function () {
    function PortalManager(portals, setPortals) {
        this.portals = portals;
        this.setPortals = setPortals;
    }
    PortalManager.prototype.openPortal = function (portal) {
        this.setPortals(__spreadArray(__spreadArray([], this.portals), [portal]));
        return portal;
    };
    PortalManager.prototype.closePortal = function (portal) {
        this.setPortals(this.portals.filter(function (item) { return item !== portal; }));
    };
    PortalManager.prototype.getPortals = function () {
        return this.portals;
    };
    PortalManager.getPortalCount = function () {
        PortalManager.portalCount++;
        return PortalManager.portalCount;
    };
    PortalManager.portalCount = 0;
    return PortalManager;
}());
exports.PortalManager = PortalManager;
//# sourceMappingURL=PortalManager.js.map